import { render, staticRenderFns } from "./DetailTable.vue?vue&type=template&id=22b35acc&scoped=true"
import script from "./DetailTable.vue?vue&type=script&lang=js"
export * from "./DetailTable.vue?vue&type=script&lang=js"
import style0 from "./DetailTable.vue?vue&type=style&index=0&id=22b35acc&scoped=true&lang=css"
import style1 from "./DetailTable.vue?vue&type=style&index=1&id=22b35acc&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b35acc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b35acc')) {
      api.createRecord('22b35acc', component.options)
    } else {
      api.reload('22b35acc', component.options)
    }
    module.hot.accept("./DetailTable.vue?vue&type=template&id=22b35acc&scoped=true", function () {
      api.rerender('22b35acc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/confirmation/Components/DetailTable.vue"
export default component.exports